module.exports = __webpack_public_path__ + "static/media/InspironParticipant.c52835dc.pdf";